/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import JSG from '@cedalo/jsg-ui';
import * as ActionTypes from '../constants/ActionTypes';
import * as messageTypes from '../constants/WebsocketMessageTypes';
import { graphManager } from '../GraphManager';
import gatewayClient from '../helper/GatewayClient';
import { getCustomInfos, pinInfo, typeInfo } from '../helper/custominfos';
import store from '../store';
import * as BackupRestoreActions from './BackupRestoreActions';
import * as UserActions from './UserActions';


// const removeSelection = () => {
// 	const user = JSON.parse(localStorage.getItem('user'));
// 	const sessionId = sessionStorage.getItem('sessionId');
// 	if (user) {
// 		const id = `${sessionId};${user.id};${user.displayName}`;
// 		graphManager.removeSelection(id);
// 	}
// };
//
// window.onbeforeunload = () => {
// 	removeSelection();
// };

export const { saveUserSettings, login, logout } = UserActions;

export const { restore, backup } = BackupRestoreActions;


const putAppState = (newState) => ({
	type: ActionTypes.SET_APP_STATE,
	newState
});
export function setAppState(newState) {
	return store.dispatch(putAppState(newState));
}

const removeNotifications = () => ({ type: ActionTypes.NOTIFICATIONS_CLEAR });

const requestFailed = (type, error) => ({
	type: messageTypes.REQUEST_FAILED,
	request: type,
	error
});

// const startProcessingMachineStep = () => ({ type: ActionTypes.START_PROCESSING_MACHINE_STEP });
// const finishedProcessingMachineStep = () => ({ type: ActionTypes.FINISHED_PROCESSING_MACHINE_STEP });

// const receiveMachineReset = machine => ({ type: ActionTypes.RECEIVE_MACHINE_RESET, machine });

const getCustomInfosForStsContainer = getCustomInfos(pinInfo(), typeInfo());

function saveProcessSettingsAndDispatch(settings, dispatch) {
	return gatewayClient
		.updateStreamSheetStreams(settings.machineId, settings.streamsheetId, settings)
		.catch((error) => {
			console.error(error);
			return dispatch(requestFailed(messageTypes.STREAMSHEET_STREAM_UPDATE_TYPE, error));
		});
}

export const clearNotifications = () => store.dispatch(removeNotifications());

export function sendCommand(command) {
	return gatewayClient.sendCommand(graphManager.getMachineId(), command).then((response) => {
		graphManager.handleCommandResponse(response);
		return response;
	});
}

export function createStreamSheet(machineId, activeItemId, options = {}) {
	return (dispatch) => {
		const { position, scope, type } = options;
		const stsContainer = JSG.StreamSheetContainer.create({ position, type }, graphManager.getGraph());
		const customInfos = getCustomInfosForStsContainer(stsContainer);
		const shapes = stsContainer.getStreamSheet().getCells().subItemsToJSON(stsContainer.getStreamSheet().model);
		return (
			gatewayClient
				.createStreamSheet(machineId, activeItemId, { customInfos, shapes }, scope)
				.catch((error) => dispatch(requestFailed(messageTypes.STREAMSHEET_CREATE, error)))
		);
	};
}

export function deleteStreamSheet(machineId, streamsheetId, scope) {
	return (dispatch) => {
		return (
			gatewayClient
				.deleteStreamSheet(machineId, streamsheetId, scope)
				.catch((error) => dispatch(requestFailed(messageTypes.STREAMSHEET_DELETE, error)))
		);
	};
}

export function updateMachineSettings(machineId, settings) {
	return async (dispatch) => {
		return gatewayClient
			.updateMachineSettings(machineId, settings)
			.catch((error) => dispatch(requestFailed(messageTypes.MACHINE_UPDATE_SETTINGS, error)));
	};
}

export function start(machineId) {
	return async (dispatch) => {
		try {
			await gatewayClient.openMachine(machineId);
			await gatewayClient.startMachine(machineId);
		} catch (error) {
			dispatch(requestFailed(messageTypes.MACHINE_START, error));
		}
	};
}

export function stop(machineId) {
	return (dispatch) => {
		return gatewayClient
			.stopMachine(machineId)
			.catch((error) => dispatch(requestFailed(messageTypes.MACHINE_STOP, error)));
	};
}

export function pause(machineId) {
	return (dispatch) => {
		return gatewayClient
			.openMachine(machineId)
			.then(() => gatewayClient.pauseMachine(machineId))
			.catch((error) => dispatch(requestFailed(messageTypes.MACHINE_PAUSE, error)));
	};
}

export function step(machineId) {
	return (dispatch) => {
		return gatewayClient
			.stepMachine(machineId)
			.catch((error) => dispatch(requestFailed(messageTypes.MACHINE_STEP, error)));
	};
}

export function saveProcessSettings(settings) {
	return (dispatch) => saveProcessSettingsAndDispatch(settings, dispatch);
}

export function showErrorDialog(titleId, messageId, values) {
	return (dispatch) => {
		dispatch(putAppState({ errorDialog: { open: true, titleId, messageId, values } }));
	};
}
